// まとめ買い割引：「詳しくはこちら」でプルダウン表示
(function buyBtnWrapDiscountToggle() {
	const wrap = document.querySelector('.product__buy-btn-wrap');
	if (!wrap) return;
	const toggle = wrap.querySelector('.product__buy-btn-wrap-link');
	const box = wrap.querySelector('.product__buy-btn-wrap-box');
	if (!toggle || !box) return;

	function setOpen(open) {
		box.classList.toggle('is-open', open);
		if (open) {
			box.removeAttribute('hidden');
		} else {
			box.setAttribute('hidden', '');
		}
		toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
	}

	toggle.addEventListener('click', function (e) {
		e.stopPropagation();
		setOpen(!box.classList.contains('is-open'));
	});

	document.addEventListener('click', function (e) {
		if (!wrap.contains(e.target)) {
			setOpen(false);
		}
	});

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && box.classList.contains('is-open')) {
			setOpen(false);
		}
	});
})();

// 商品詳細プログレス: 990px 以上は #product__media 縦スクロール、未満はギャラリー横スワイプ（横スクロール量）
(function progressBar() {
	var bar = document.querySelector('#product__media .progress-bar');
	var target = document.getElementById('product__media');
	if (!bar || !target) return;

	var mql = window.matchMedia('(min-width: 990px)');
	var mode = null;
	var gallery = null;
	var ro = null;

	function updateVertical() {
		var maxScroll = target.scrollHeight - target.clientHeight;
		var pct = 0;
		if (maxScroll > 0) {
			pct = (target.scrollTop / maxScroll) * 100;
		}
		if (pct < 0) pct = 0;
		if (pct > 100) pct = 100;
		bar.style.width = '';
		bar.style.height = pct + '%';
	}

	function updateHorizontal() {
		gallery = target.querySelector('[id^="Slider-Gallery-"]');
		if (!gallery) {
			bar.style.height = '100%';
			bar.style.width = '100%';
			return;
		}
		var maxScroll = gallery.scrollWidth - gallery.clientWidth;
		var pct = maxScroll > 0 ? (gallery.scrollLeft / maxScroll) * 100 : 100;
		if (pct < 0) pct = 0;
		if (pct > 100) pct = 100;
		bar.style.height = '100%';
		bar.style.width = pct + '%';
	}

	function onWindowResize() {
		if (mql.matches) {
			updateVertical();
		} else {
			if (gallery) {
				gallery.removeEventListener('scroll', onGalleryScroll);
			}
			gallery = target.querySelector('[id^="Slider-Gallery-"]');
			if (gallery) {
				gallery.addEventListener('scroll', onGalleryScroll, { passive: true });
			}
			updateHorizontal();
		}
	}

	function onGalleryScroll() {
		updateHorizontal();
	}

	function onTargetScroll() {
		updateVertical();
	}

	function tearDown() {
		target.removeEventListener('scroll', onTargetScroll);
		if (gallery) {
			gallery.removeEventListener('scroll', onGalleryScroll);
		}
		gallery = null;
		window.removeEventListener('resize', onWindowResize);
		if (ro) {
			ro.disconnect();
			ro = null;
		}
	}

	function applyMode() {
		var next = mql.matches ? 'desktop' : 'mobile';
		tearDown();
		mode = next;
		if (next === 'desktop') {
			bar.style.width = '';
			bar.style.height = '0%';
			target.addEventListener('scroll', onTargetScroll, { passive: true });
			window.addEventListener('resize', onWindowResize);
			if (typeof ResizeObserver !== 'undefined') {
				ro = new ResizeObserver(function () {
					updateVertical();
				});
				ro.observe(target);
			}
			updateVertical();
		} else {
			bar.style.width = '0%';
			bar.style.height = '100%';
			gallery = target.querySelector('[id^="Slider-Gallery-"]');
			if (gallery) {
				gallery.addEventListener('scroll', onGalleryScroll, { passive: true });
			}
			window.addEventListener('resize', onWindowResize);
			if (typeof ResizeObserver !== 'undefined' && gallery) {
				ro = new ResizeObserver(function () {
					updateHorizontal();
				});
				ro.observe(gallery);
			}
			updateHorizontal();
		}
	}

	if (mql.addEventListener) {
		mql.addEventListener('change', applyMode);
	} else {
		mql.addListener(applyMode);
	}
	applyMode();
}());
